import { useState, useRef, useCallback, useEffect, Key } from 'react';
import ArrowUp from '../../assets/svg/arrow-up';


export interface P2MobileNavItemProps{
    item:any;
    resetParentHeight:any;
}

export default function P2MobileNavItem({item, resetParentHeight}:P2MobileNavItemProps) {
  const [isOpened, setIsOpened] = useState(false);
  const bodyDiv = useRef<HTMLDivElement|null>(null)
  const [sectionHeight, setSectionHeight] = useState(0);

  const toggleMenu = useCallback(() => {
    setIsOpened(state => !state);
    resetParentHeight((isOpened ? -1 : 1) * sectionHeight);
  }, [isOpened, resetParentHeight, sectionHeight]);

  const resetThisHeight = useCallback((diff:any) => {
    resetParentHeight(diff);
    setSectionHeight(state => state + diff);
  }, [resetParentHeight]);

  useEffect(() => {
    const callback = () => setSectionHeight(bodyDiv.current?.scrollHeight?bodyDiv.current?.scrollHeight:0);
    callback();
    window.addEventListener('resize', callback);
    return () => window.removeEventListener('resize', callback);
  }, []);

  return (
    <div className="polymer-header-mobile-nav-item"> 
      <div className="polymer-header-mobile-nav-item-name" >
        <a className='text-decoration-none' style={{left:'0px', width:"100%", color:"black", fontWeight:700, fontSize:"1rem"}} href={item.url}>{item.name}</a>  
        <div onClick={toggleMenu} style={{margin:"0 10px 0"}}>
            <ArrowUp isRotated={!isOpened} />
        </div>
      </div>
      
      <div 
        className="polymer-header-mobile-nav-item-sections"
        style={{
          height: isOpened ? sectionHeight : 0,
        }}
        ref={bodyDiv}
      >
        {item.sections && item.sections.map((section: any, sectionIndex: Key | null | undefined) => {
          const key = `mobile_group_nav_item_${sectionIndex}`;
          return (
            <P2MobileNavItemSection 
              section={section} 
              key={key} 
              resetParentHeight={resetThisHeight}
            />
          )
        })}
      </div>
    </div>
  )
}

export interface P2MobileNavItemSectionProps{
    section:any;
    resetParentHeight:any;
}


const P2MobileNavItemSection = ({ section, resetParentHeight }:P2MobileNavItemSectionProps) => {

  return (
    <div className="polymer-header-mobile-nav-item">
      <a className="polymer-header-mobile-nav-item-name ps-5 text-decoration-none" href={section.url}>
        <div>{section.header}</div>
      </a>
    </div>
  )
}